import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import dummyimage from "../../../../images/dummyimage.jpeg";
import { getImageUrl } from '../../../pages/Artist/ArtistAvatar';


const upcomingBlog = [
	{ day: '12', week: 'Sat', ticket: '561' },
	{ day: '19', week: 'Tus', ticket: '450' },
	{ day: '28', week: 'Wed', ticket: '500' },
];

const UpcomingEventSection = ({ events }) => {
	const [value, onChange] = useState(new Date());

	const [data, setData] = useState(upcomingBlog);
	const [refresh, setRefresh] = useState(false);
	const handleLoad = () => {
		setRefresh(true);
		setTimeout(() => {
			setData([
				...data,
				data[Math.floor(Math.random() * Math.floor(data.length - 1))],
			]);
			setRefresh(false);
		}, 1000);
	};
	return (
		<>
			<div className="card event-bx">
				<div className="card-header border-0 mb-0">
					<h4 className="card-title mb-1 font-w500">Upcoming Events</h4>
				</div>
				<div className="card-body pb-0 pt-0 dz-scroll">
					{events?.length === 0 && <div className="text-center h-100 d-flex justify-content-center align-items-center"><h4>No Upcoming Events</h4></div>}
					{events.map((item, index) => (
						<div className="media mb-5 align-items-center event-list d-flex" key={index}>
							<div className="p-3 text-center me-3 date-bx bgl-primary">
								<h2 className="mb-0 text-secondary fs-28 font-w600">{new Date(item.date).getDate()}</h2>
								<h5 className="mb-1 text-black">{new Date(item.date).toLocaleDateString("en-US", { weekday: "short" })}</h5>
							</div>
							<div className="media-body px-0">
								<h4 className="mt-0 mb-1 text-primary">{item?.project?.conceptTitle}</h4>
								<h6 className="mt-0 mb-2 text-primary">{item?.project?.artist?.firstName}{" "}{item?.project?.artist?.lastName}</h6>
								<ul className="fs-14 list-inline mb-2 d-flex justify-content-between">
									<li><img height={20} width={20} src={getImageUrl(item?.project?.artForm?.icon) ?? dummyimage} /> {item?.project?.artForm?.name} {item?.project?.genre?.name ? `|` + item?.project?.genre?.name : ''}</li>
								</ul>
							</div>
						</div>
					))}

				</div>
			</div>

		</>
	)
}
export default UpcomingEventSection; 